/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { ConversationClosedPayloadSideEffectType } from "./ConversationClosedPayloadSideEffectType";

export interface ConversationClosedPayload {
  side_effect_type: ConversationClosedPayloadSideEffectType;
  conversation_id: string;
}
